// extracted by mini-css-extract-plugin
export default {"main":"index_main__RM5qs","mainArea":"index_mainArea__+O6UC","operationArea":"index_operationArea__4glQq"};